export default {
	lvyoucuxiao: '旅游促销高达50%折扣',
	guanzhuwomen: '关注我们50%折扣',
	miyuetaocan: '蜜月套餐',
	lvyoucuxiaohuodong: '旅行促销活动',
	dujiatiantang: '度假天堂',
	zhongguo: '中国',
	yingguo: '新西兰',
	aodaliya: '澳大利亚',
	taiguo: '泰国',
	xianggang: '香港',
	foluolidazhou: '奥克兰',
	xini: '悉尼',
	mangu: '曼谷',
	shanshuizhimei: '山水之美',
	xinxilandemeijing: '新西兰的美景',
	xinigejuyuan: '悉尼歌剧院',
	zaimanguyaozuodeshiqing: '在曼谷要做的事情',
	lvyoucu: '旅行促销',
	daizhewomende: '带着我们的蜜月套餐逃到浪漫的天堂。在您的私人别墅放松身心，享受水疗护理，欣赏迷人的海景。',
	tongguodaoyou: '通过导游和烹饪课程探索当地文化。让我们处理好细节，从此开始你的幸福生活。',
	lijiyuding: '立即预订，度过难忘的蜜月。',
	jingdu: '京都4d3n航班 + 酒店套餐2件',
	pujidao: '普吉岛淡季4天 航班 + 酒店套餐',
	xianggangfei: '香港飞冲绳机票',
	xinidaolundun: '悉尼飞伦敦机票',
	malaixiyarelangdao: '马来西亚热浪岛+沙滩漫步+夜间追寻蓝泪',
	yidianshan: '伊甸山',
	aokelan: '奥克兰',
	pingfen: '评分',
	yidianshanjianjie: '奥克兰四周被海洋和火山环抱，地标之一的伊甸山便是座死火山。 伊甸山至今仍保存奥克兰原始的毛利堡垒，也是俯视奥克兰的好地方。',
	dibiaotiankongta: '地标天空塔',
	dibiaotiankongtajianjie: '塔顶360°的瞭望台可将市区延伸至东西两岸全景尽收眼底。 在晴天可以看到方圆82公里之远，这里是欣赏奥克兰夜景的最佳地点。',
	habirencun: '哈比人村',
	habirencunjianjie: '魔戒哈比人那个与世无争的夏尔村庄，应该是好多人向往的世界！相比新西兰其他了无人烟的大自然景点，最热闹的应该就是这里了，有些区域甚至要用拥挤来形容，可见这部电影的影响力有多大！',
	lanquan: '蓝泉',
	lanquanjianjie: '参观完哈比人村，可以安排两个小时到附近的秘景Blue Spring，大部分人去完都会用梦幻来形容。 泉水源自于玛玛库高原，极致的纯净，需经由100年的层层过滤才到达地表。 听闻新西兰70%的瓶装水都来自这里哦。',
	jiduchengzhiwuyuan: '基督城植物园',
	jiduchengzhiwuyuanjianjie: '基督城植物园为基督城市民平日休闲散心的公园。 园区内有许多的主题小花园，香草园、玫瑰园、温室花园等，一年四季开满了美丽的花朵，是新西兰最棒的植物园之一。',
	remenjingxuan: '热门旅游精选',
	remenjingxuanbiaoti2: '热门旅游精选',
	remenjingxuanmiaoshu2: '热门旅游精选，品质之选，带您探索世界精彩，享受完美假期。',
	remenjingxuanlianjiemiaoshu2: '为您精选最受欢迎的旅游目的地和套餐，无论您是想放松身心、体验文化还是享受美食，都能在这里找到心仪的选择',
	remenjingxuanlianjie2: '立即预订，开启您的美好旅程！',
	remenjingxuanbiaoti3: '限时特惠蜜月套餐',
	remenjingxuanmiaoshu3: '每月套餐，专属浪漫，甜蜜时光，见证爱情，开启幸福旅程。',
	remenjingxuanlianjiemiaoshu3: '抓住机会，享受我们为您量身定制的限时特惠旅游套餐。无论您喜欢海滩度假、城市探险还是文化体验，我们都有适合您的选择',
	remenjingxuanlianjie3: '立即预订，开启您的梦想之旅，不要错过这些难得的优惠！',
	remenjingxuanbiaoti4: '探索世界，尽享优惠',
	remenjingxuanmiaoshu4: '探索世界，即刻出发，尽享优惠，开启您的精彩旅程，不容错过',
	remenjingxuanlianjiemiaoshu4: '无论您是寻求刺激的探险家，还是渴望放松的度假者，我们都能满足您的需求',
	remenjingxuanlianjie4: '现在就预定，享受超值优惠',
	remenjingxuanbiaoti5: '度假天堂，专属定制，打造完美假期',
	remenjingxuanmiaoshu5: '度假天堂，放松身心，享受阳光沙滩，让烦恼烟消云散，尽情拥抱美好',
	remenjingxuanlianjiemiaoshu5: '带着我们的蜜月套餐逃到浪漫的天堂，在您的私人别墅放松身心，享受水疗护理，欣赏迷人的海景',
	remenjingxuanlianjie5: '现在就预定，从此开始你的幸福生活！',
	xinjiapomangu: '新加坡飞曼谷机票',
	xinjiapoxianggang: '新加坡飞香港机票',
	xinjiapojilongpo: '新加坡飞吉隆坡机票',
	xinjiapoguangzhou: '新加坡飞广州机票',
	xinjiapoxini: '新加坡飞悉尼机票',
	xiangganglundun: '香港飞伦敦机票',
	xianggangxini: '香港飞悉尼机票',
	xinjiapobalidao: '新加坡飞巴厘岛机票',
	xianggangyadian: '香港飞雅典机票',
	xianggangkailuo: '香港飞开罗机票',
	niuyuebeihaidao: '纽约飞北海道机票',
	xianggangmilan: '香港飞米兰机票',
	xianggangbali: '香港飞巴黎机票',
	niuyueshengbaoluo: '纽约飞圣保罗机票',
	niuyueyatelanda: '纽约飞亚特兰大机票',
	xianbenna: '仙本那',
	malaixiya: '马来西亚',
	sulishi: '苏黎世',
	ruishi: '瑞士',
	riyuetan: '日月潭',
	taiwan: '中国·台湾',
	xiyatu: '西雅图',
	huashengdun: '美国·华盛顿',
	mudidibiaoti1: '热门景点',
	mudidimiaoshu1: '仙本那的美景',
	mudidibiaoti2: '热门景点',
	mudidimiaoshu2: '苏黎世的美景',
	mudidibiaoti3: '热门景点',
	mudidimiaoshu3: '台湾的美景',
	mudidibiaoti4: '热门景点',
	mudidimiaoshu4: '西雅图的美景',
	mudidijingdianbiaoti1: '卡帕莱岛',
	mudidijingdianmiaoshu1: '卡帕莱岛，一个漂浮在碧海之上的梦幻天堂，被清澈见底的海水和五彩斑斓的珊瑚礁环绕宛如一颗遗落在海上的璀璨宝石，宁静而又充满生机。',
	mudidijingdianbiaoti2: '敦沙卡兰海洋公园',
	mudidijingdianmiaoshu2: '敦沙卡兰海洋公园，不仅可以潜水、浮潜，还可以徒步登山，欣赏壮丽的全景，体验当地的文化，让您的旅程充满探险和乐趣，收获难忘的回忆。',
	mudidijingdianbiaoti3: '汀巴汀巴岛',
	mudidijingdianmiaoshu3: '汀巴汀巴岛，是一个未被过度开发的宁静小岛，以其原始的自然风光和丰富的海洋生物而著称。这里拥有清澈的海水、美丽的珊瑚礁和多样的海洋生物，是潜水、浮潜和放松身心的绝佳去处。岛上环境宁静，适合寻求远离喧嚣、亲近自然的旅行者。',
	mudidijingdianbiaoti4: '西巴丹岛',
	mudidijingdianmiaoshu4: '在西巴丹岛潜水，您将有机会与成群的海龟、鲨鱼和梭鱼共舞，感受大自然的壮丽和神奇这是一次难忘的水下探险，让您终生难忘。',
	mudidijingdianbiaoti5: '珍珠岛',
	mudidijingdianmiaoshu5: '在珍珠岛，您可以尽情享受阳光、沙滩、海水，体验各种水上活动，探索美丽的海底世界感受大自然的魅力。您也可以在沙滩上漫步，欣赏日出日落的壮丽景色，让心灵得到彻底的放松。',
	mudidijingdianbiaoti6: '军舰岛',
	mudidijingdianmiaoshu6: '军舰岛，一个充满活力和乐趣的海岛，以其迷人的海滩、清澈的海水和丰富的海洋生物而闻名。在这里，您可以尽情享受浮潜的乐趣，与各种海洋生物亲密接触，感受海洋的魅力。',
	mudidijingdianbiaoti7: '苏黎世大教堂',
	mudidijingdianmiaoshu7: '苏黎世大教堂，以其独特的双塔和雄伟的建筑风格吸引着无数游客。您可以在这里感受历史的厚重，欣赏精美的艺术品，登上塔楼俯瞰苏黎世美景。',
	mudidijingdianbiaoti8: '瑞士国立博物馆',
	mudidijingdianmiaoshu8: '瑞士国立博物馆，是一个充满知识和趣味的博物馆。您可以在这里探索瑞士的历史和文化,欣赏精美的艺术品，感受瑞士的独特魅力。',
	mudidijingdianbiaoti9: '苏黎世美术馆',
	mudidijingdianmiaoshu9: '苏黎世美术馆(Kunsthaus Zürich)，是瑞士最重要的美术馆之一，收藏了从中世纪到现代的各种艺术作品。馆内藏品丰富多样，包括绘画、雕塑、版画、摄影等，涵盖了瑞士和国际艺术家的作品。您可以在这里欣赏到印象派、表现主义、超现实主义等不同流派的艺术作品。',
	mudidijingdianbiaoti10: '圣母教堂',
	mudidijingdianmiaoshu10: '圣母教堂，是一座历史悠久的教堂，其历史可以追溯到9世纪。教堂不仅是宗教场所也是重要的文化遗产。除了夏加尔的彩色玻璃窗，教堂内还有其他值得欣赏的艺术品如管风琴和壁画。教堂的尖塔也是苏黎世的标志性景观之一。',
	mudidijingdianbiaoti11: '班霍夫大街',
	mudidijingdianmiaoshu11: '班霍夫大街，不仅是购物的场所，也是苏黎世的中心。这条街道连接着苏黎世火车站和苏黎世湖，是游客必经之地。您可以在这里欣赏到苏黎世的城市风光，感受这座城市的繁华和活力。此外，街道两旁还有许多咖啡馆和餐厅，供您休息和放松。',
	mudidijingdianbiaoti12: '林登霍夫山',
	mudidijingdianmiaoshu12: '林登霍夫山，是苏黎世的标志性景点之一。在这里，您不仅可以欣赏到美丽的城市风光还可以感受到苏黎世的历史氛围。山顶的公园是当地居民休闲放松的好去处，您可以在这里散步、休息，享受宁静的时光。此外，这里也是拍摄苏黎世全景的绝佳地点。',
	mudidijingdianbiaoti13: '日月潭',
	mudidijingdianmiaoshu13: '日月潭(Sun Moon Lake)，是台湾最著名的景点之一，也是台湾最大的天然湖泊。湖面被拉鲁岛分隔，北侧形如太阳，南侧形如月亮，因此得名。日月潭周围群山环绕，景色优美，湖光山色相映成趣。这里不仅有美丽的自然风光，还有丰富的原住民文化，是体验台湾文化和自然风光的理想之地。',
	mudidijingdianbiaoti14: '九族文化村',
	mudidijingdianmiaoshu14: '九族文化村，是台湾一个独具特色的主题乐园，以台湾九大原住民族的文化为主题，展示了各族的生活方式、传统艺术和建筑特色。您可以在这里参观原住民的传统家屋、欣赏精彩的歌舞表演、体验原住民的手工艺，还能乘坐刺激的游乐设施，是一个集文化、娱乐、教育于一体的综合性乐园。',
	mudidijingdianbiaoti15: '日月潭缆车',
	mudidijingdianmiaoshu15: '日月潭缆车，采用最新的缆车技术，乘坐舒适安全。缆车分为普通车厢和水晶车厢，水晶车厢的底部是透明的，可以让您更清晰地欣赏脚下的美景，体验更加刺激。缆车全程约10分钟您可以尽情享受高空欣赏美景的乐趣，是日月潭旅游不可错过的体验。',
	mudidijingdianbiaoti16: '阿里山国家风景区',
	mudidijingdianmiaoshu16: '阿里山，不仅是自然景观的代表，也是台湾的文化象征。这里有丰富的动植物资源，是生态旅游的理想之地。您可以漫步于森林步道，呼吸新鲜空气，欣赏美丽的自然风光。此外,阿里山的日出和云海更是吸引了无数游客前来观赏，是体验台湾高山之美的必游之地。',
	mudidijingdianbiaoti17: '清境农场',
	mudidijingdianmiaoshu17: '清境农场，是台湾著名的高山农场，以其优美的自然风光、欧洲风格的建筑和可爱的绵羊秀而闻名，是体验高山农场生活的理想之地。',
	mudidijingdianbiaoti18: '彩虹眷村',
	mudidijingdianmiaoshu18: '彩虹眷村，以其独特的彩绘艺术而闻名，每一面墙壁都充满了不同的色彩和图案，仿佛置身于一个童话世界。您可以在这里漫步，欣赏各种有趣的彩绘，感受艺术的魅力。此外，彩虹眷村的故事也感动了许多人，让大家更加珍惜身边的美好事物。',
	mudidijingdianbiaoti19: '太空针塔',
	mudidijingdianmiaoshu19: '太空针塔，是美国西雅图最著名的地标之一，以其独特的造型和顶部的观景台而闻名游客可以乘坐高速电梯到达观景台，欣赏到360度无死角的西雅图城市全景，包括普吉特海湾、奥林匹克山脉和雷尼尔山等壮丽景色。太空针塔不仅是西雅图的象征，也是一个重要的旅游景点。',
	mudidijingdianbiaoti20: '派克市场',
	mudidijingdianmiaoshu20: '派克市场，位于西雅图市中心，是一个充满活力和人情味的农贸市场。这里有各种各样的摊位，从新鲜的海鲜到当地的农产品，应有尽有。您可以在这里品尝到美味的当地美食，欣赏到街头艺人的表演，还可以与当地居民互动，感受西雅图的独特魅力。派克市场是一个充满惊喜和乐趣的地方。',
	mudidijingdianbiaoti21: '奇胡利玻璃艺术园',
	mudidijingdianmiaoshu21: '奇胡利玻璃艺术园，以其独特的玻璃艺术品和展览方式而闻名。您可以在这里漫步，欣赏各种精美的玻璃雕塑和装置，感受玻璃艺术的独特魅力。艺术园内还设有玻璃温室，展示了奇胡利的大型玻璃装置，让您仿佛置身于一个奇幻的玻璃世界。奇胡利玻璃艺术园是一个充满艺术气息和视觉享受的地方。',
	mudidijingdianbiaoti22: '华盛顿大学',
	mudidijingdianmiaoshu22: '华盛顿大学，是美国西海岸最著名的公立研究型大学之一，位于西雅图市中心。这所大学以其美丽的校园、卓越的学术水平和强大的研究实力而闻名，拥有世界一流的图书馆、实验室和研究中心。华盛顿大学不仅是学术研究的殿堂，也是一个充满活力和多元文化的地方。',
	mudidijingdianbiaoti23: '飞行博物馆',
	mudidijingdianmiaoshu23: '飞行博物馆，不仅有各种各样的飞机，还有许多互动展品和模拟器，让您身临其境地体验飞行。您可以在这里参观波音公司最初的工厂，了解波音公司的发展历史，还可以体验到飞行模拟器的乐趣。飞行博物馆是一个适合各个年龄段的游客参观的景点，无论是航空爱好者还是普通游客，都能在这里找到乐趣。',
	mudidijingdianbiaoti24: '西雅图水族馆',
	mudidijingdianmiaoshu24: '西雅图水族馆，位于西雅图海滨，是一个展示太平洋西北部海洋生物的著名水族馆。这里有各种各样的海洋生物，包括海獭、海豹、章鱼、水母和各种鱼类，您可以在这里近距离观察这些可爱的生物，并了解到它们的习性和栖息地。西雅图水族馆不仅是一个观赏海洋生物的地方，也是一个学习海洋知识和保护海洋环境的场所。',
};
